import { render, staticRenderFns } from "./JoinFinish.vue?vue&type=template&id=6139a0e8&scoped=true"
import script from "./JoinFinish.vue?vue&type=script&lang=js"
export * from "./JoinFinish.vue?vue&type=script&lang=js"
import style0 from "./JoinFinish.vue?vue&type=style&index=0&id=6139a0e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6139a0e8",
  null
  
)

export default component.exports